import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

const NotFound = lazy(() => import("../pages/NotFound"));
const Home = lazy(() => import("../pages/home/page"));
const PaymentMethodsPage = lazy(() => import("../pages/payments/page"));
const MonterreyAdventistaPage = lazy(() => import("../pages/special-package/monterrey-adventista"));
const ColombiaPlusLandingPage = lazy(() => import("../pages/special-package/colombia-plus"));
const CordobaAaLandingPage = lazy(() => import("../pages/special-package/cordoba-aa"));
const CrownParadiseClubCancunPage = lazy(() => import("../pages/hotels/crown-paradise-club-cancun"));
const CrownParadiseRoomPage = lazy(() => import("../pages/hotels/crown-paradise-room"));
const SpecialPackageLandingPage = lazy(() => import("../pages/special-package/page"));
const TapachulaAaLandingPage = lazy(() => import("../pages/special-package/tapachula-aa"));
const TripPage = lazy(() => import("../pages/trip/page"));
const ShortTripUrl = lazy(() => import("../pages/trip/short-url"));
const DestinationTripsPage = lazy(() => import("../pages/destinations/page"));
const SororaTampicoPage = lazy(() => import("../pages/events/sorora-tampico"));
const GreciaItaliaCruceroPage = lazy(() => import("../pages/special-package/grecia-italia-crucero"));
const MscFantasiaMediterraneoPage = lazy(() => import("../pages/special-package/msc-fantasia-mediterraneo"));
const MatrimonialCongressEventPage = lazy(() => import("../pages/events/matrimonial-congress"));
const BahiaMatrimonialCongressEventPage = lazy(() =>
  import("../pages/events/matrimonial-congress").then((module) => ({
    default: module.BahiaMatrimonialCongressEventPage,
  })),
);
const October8MatrimonialCongressEventPage = lazy(() =>
  import("../pages/events/matrimonial-congress").then((module) => ({
    default: module.October8MatrimonialCongressEventPage,
  })),
);
const PrivacyNoticePage = lazy(() =>
  import("../pages/legal/page").then((module) => ({ default: module.PrivacyNoticePage })),
);
const TermsAndConditionsPage = lazy(() =>
  import("../pages/legal/page").then((module) => ({ default: module.TermsAndConditionsPage })),
);

const routes: RouteObject[] = [
  {
    path: "/viajes/crucero-mediterraneo-msc-fantasia-2027",
    element: <MscFantasiaMediterraneoPage />,
  },
  {
    path: "/viajes/crucero-mediterraneo-msc-fantasia-2027/",
    element: <MscFantasiaMediterraneoPage />,
  },
  {
    path: "/viajes/grecia-italia-crucero-2027",
    element: <GreciaItaliaCruceroPage />,
  },
  {
    path: "/viajes/grecia-italia-crucero-2027/",
    element: <GreciaItaliaCruceroPage />,
  },
  {
    path: "/viajes/maestros-adventistas-monterrey-2027/",
    element: <MonterreyAdventistaPage />,
  },
  {
    path: "/metodos-y-formas-de-pago/",
    element: <PaymentMethodsPage />,
  },
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/terminos-y-condiciones/",
    element: <TermsAndConditionsPage />,
  },
  {
    path: "/aviso-de-privacidad/",
    element: <PrivacyNoticePage />,
  },
  {
    path: "/viaje/:slugMt.html",
    element: <TripPage />,
  },
  {
    path: "/viajes/cusco-lima-aa-2026",
    element: <SpecialPackageLandingPage />,
  },
  {
    path: "/viajes/cusco-lima-aa-2026/",
    element: <SpecialPackageLandingPage />,
  },
  {
    path: "/viajes/congreso-regional-aa-tapachula-2026",
    element: <TapachulaAaLandingPage />,
  },
  {
    path: "/viajes/congreso-regional-aa-tapachula-2026/",
    element: <TapachulaAaLandingPage />,
  },
  {
    path: "/viajes/reunion-nacional-aa-cordoba-2026",
    element: <CordobaAaLandingPage />,
  },
  {
    path: "/viajes/reunion-nacional-aa-cordoba-2026/",
    element: <CordobaAaLandingPage />,
  },
  {
    path: "/viajes/explora-colombia-plus",
    element: <ColombiaPlusLandingPage />,
  },
  {
    path: "/viajes/explora-colombia-plus/",
    element: <ColombiaPlusLandingPage />,
  },
  {
    path: "/eventos/congreso-matrimonial-2026",
    element: <MatrimonialCongressEventPage />,
  },
  {
    path: "/eventos/congreso-matrimonial-2026/",
    element: <MatrimonialCongressEventPage />,
  },
  {
    path: "/eventos/congreso-matrimonial-2026-10-8",
    element: <October8MatrimonialCongressEventPage />,
  },
  {
    path: "/eventos/congreso-matrimonial-2026-10-8/",
    element: <October8MatrimonialCongressEventPage />,
  },
  {
    path: "/eventos/congreso-matrimonial-bahia-principe-2026",
    element: <BahiaMatrimonialCongressEventPage />,
  },
  {
    path: "/eventos/congreso-matrimonial-bahia-principe-2026/",
    element: <BahiaMatrimonialCongressEventPage />,
  },
  {
    path: "/eventos/congreso-sorora-tampico-2026",
    element: <SororaTampicoPage />,
  },
  {
    path: "/eventos/congreso-sorora-tampico-2026/",
    element: <SororaTampicoPage />,
  },
  {
    path: "/eventos/nombredelevento",
    element: <Navigate to="/eventos/congreso-matrimonial-2026" replace />,
  },
  {
    path: "/eventos/nombredelevento/",
    element: <Navigate to="/eventos/congreso-matrimonial-2026" replace />,
  },
  {
    path: "/hoteles/crown-paradise-club-cancun",
    element: <CrownParadiseClubCancunPage />,
  },
  {
    path: "/hoteles/crown-paradise-club-cancun/",
    element: <CrownParadiseClubCancunPage />,
  },
  {
    path: "/hoteles/crown-paradise-club-cancun/habitaciones/:roomSlug",
    element: <CrownParadiseRoomPage />,
  },
  {
    path: "/hoteles/crown-paradise-club-cancun/habitaciones/:roomSlug/",
    element: <CrownParadiseRoomPage />,
  },
  {
    path: "/viajes/:destino",
    element: <DestinationTripsPage />,
  },
  {
    path: "/viajes/:destino/",
    element: <DestinationTripsPage />,
  },
  {
    path: "/cruceros",
    element: <Navigate to="/viajes/cruceros/" replace />,
  },
  {
    path: "/:mt",
    element: <ShortTripUrl />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
